import { Form, Input, Select, Space } from "antd";
import { useState, useEffect, useCallback } from "react";
import { countryCodes } from "../../constant/countryCodes";

const PhoneInputField = (props) => {
  const { value, onChange, split } = props;
  const [countryCode, setCountryCode] = useState("+44");
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    if (split && value) {
      // When split mode, expect value to be an object
      if (typeof value === "object") {
        setCountryCode(value.phone_country_code || "+44");
        setPhoneNumber(value.phone || "");
      }
    } else if (value && typeof value === "string") {
      // Original behavior for combined string
      const matched = countryCodes.find((c) => value.startsWith(c.code));
      if (matched) {
        setCountryCode(matched.code);
        setPhoneNumber(value.slice(matched.code.length));
      }
    }
  }, [value, split]);

  const triggerChange = useCallback(
    (code, number) => {
      if (split) {
        // Return object with separate fields
        onChange?.({
          phone_country_code: code,
          phone: number,
        });
      } else {
        // Return combined string
        onChange?.(code + number);
      }
    },
    [onChange, split],
  );

  const onCountryCodeChange = useCallback(
    (newCode) => {
      setCountryCode(newCode);
      triggerChange(newCode, phoneNumber);
    },
    [phoneNumber, triggerChange],
  );

  const onPhoneNumberChange = useCallback(
    (e) => {
      const newNumber = e.target.value.replace(/\D/g, "");
      setPhoneNumber(newNumber);
      triggerChange(countryCode, newNumber);
    },
    [countryCode, triggerChange],
  );

  return (
    <Space.Compact style={{ display: "flex" }}>
      <Select
        value={countryCode}
        onChange={onCountryCodeChange}
        style={{ width: "auto" }}
      >
        {countryCodes.map((item) => (
          <Select.Option key={item.code} value={item.code}>
            {item.flag} {item.code}
          </Select.Option>
        ))}
      </Select>
      <Input
        value={phoneNumber}
        onChange={onPhoneNumberChange}
        placeholder="7xx xxx xxxx"
        type="tel"
      />
    </Space.Compact>
  );
};

const PhoneInput = (props) => {
  const { split, ...restProps } = props;

  return (
    <Form.Item
      label="Phone Number"
      rules={
        split
          ? [
              {
                required: true,
                validator: (_, value) => {
                  if (!value || !value.phone) {
                    return Promise.reject(
                      new Error("Please enter your phone number"),
                    );
                  }
                  if (!/^[0-9]{10,16}$/.test(value.phone)) {
                    return Promise.reject(
                      new Error(
                        "Please enter a valid phone number (10–16 digits)",
                      ),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]
          : [
              {
                required: true,
                message: "Please enter your phone number",
              },
              {
                pattern: /^\+?[0-9]{10,16}$/,
                message:
                  "Please enter a valid phone number (10–16 digits, + allowed)",
              },
            ]
      }
      name={props?.name || "mobile_number"}
      {...restProps}
    >
      <PhoneInputField split={split} />
    </Form.Item>
  );
};

export default PhoneInput;
